import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  TextField,
} from "@material-ui/core";
import TextEditorComponent from "../textEditor/TextEditor";
import ImageUpload from "../../containers/upload/imageUpload";
import ResponsiveDatePicker from "../../../components/DatePicker";
import dayjs from "dayjs";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    padding: "3vh 3%",
    "@media (max-width: 600px)": {
      padding: "3vh 0%",
      marginLeft: "-15px",
      width: "109%",
    },
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
  },
  cardActions: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "15px",
  },
  title: {
    margin: "10px 0",
  },
  input: {
    margin: "10px 0",
  },
}));

export default ({ title, onSubmit, isLoading, baseContentData }) => {
  const classes = useStyles();
  const [state, setState] = useState(
    baseContentData._id
      ? {
          name: baseContentData.name,
          pictureUrl: baseContentData.pictureUrl,
          weblink: baseContentData.weblink,
        }
      : {
          name: "",
          pictureUrl: "",
          weblink: "",
        }
  );

  const handleChange = (event) => {
    const { id, value } = event.target;

    setState({ ...state, [id]: value });
  };

  const handleFileUploaded = (pictureUrl) =>
    setState((prevState) => ({ ...prevState, pictureUrl }));

  const handleSubmit = () => {
    onSubmit(state);
  };

  return (
    <Container justify="center" maxWidth="md">
      <Card className={classes.cardRoot}>
        <CardHeader title={title || "Article Form"} />
        <CardContent className={classes.cardContent}>
          <TextField
            id="name"
            label="Name"
            variant="outlined"
            className={classes.name}
            value={state.name}
            onChange={handleChange}
            required
          />
          <TextField
            id="weblink"
            label="Partner's url"
            placeholder="Add Partner's Web Address, ex: https://example.com..."
            variant="outlined"
            className={classes.input}
            value={state.weblink}
            onChange={handleChange}
            required
          />

          <div className={classes.input}>
            <ImageUpload
              onFileUploaded={handleFileUploaded}
              defaultImg={state.pictureUrl}
            />
          </div>
        </CardContent>
        <CardActions className={classes.cardActions}>
          <Button
            variant="outlined"
            onClick={handleSubmit}
            sx={{
              color: "#E00186",
              border: "1px solid #E00186",
              "&:hover": {
                color: "#fff",
                backgroundColor: "#E00186",
                border: "1px solid #E00186",
              },
            }}
          >
            {isLoading ? "Saving..." : "Save Work"}
          </Button>
        </CardActions>
      </Card>
    </Container>
  );
};
